import { View, Text, Pressable } from "react-native";
import { colors, typography, spacing, radii } from "../theme/tokens";
import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";

type Props = {
  variant: "info" | "warning" | "encouragement" | "important";
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  /** Stable analytics identifier; `actionLabel` travels as the event label. */
  action?: string;
};

const VARIANT_COLORS: Record<Props["variant"], string> = {
  info: colors.blue,
  warning: colors.gold,
  encouragement: colors.green,
  important: colors.coral,
};

export function ActionBanner({
  variant,
  message,
  actionLabel,
  onAction,
  action,
}: Props) {
  const accentColor = VARIANT_COLORS[variant];
  const capturePress = usePressCapture("ActionBanner");

  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        gap: spacing.md,
        padding: spacing.md,
        borderRadius: radii.md,
        backgroundColor: `${accentColor}12`,
        borderWidth: 1,
        borderColor: `${accentColor}25`,
      }}
    >
      <View style={{ flex: 1 }}>
        <Text
          style={{
            fontFamily: typography.families.sans,
            fontSize: typography.sizes.base,
            color: colors.text,
            lineHeight: typography.sizes.base * 1.5,
          }}
        >
          {message}
        </Text>
      </View>
      {actionLabel && onAction && (
        <Pressable
          onPress={() => {
            capturePress(pressLabel(actionLabel), action);
            onAction();
          }}
        >
          <Text
            style={{
              fontFamily: typography.families.sansBold,
              fontSize: typography.sizes.sm,
              color: accentColor,
            }}
          >
            {actionLabel}
          </Text>
        </Pressable>
      )}
    </View>
  );
}
